export const announcementBannerStyles = {
	mainContainer: {
		backgroundColor: 'colors.green',
		width: '100%',
		textAlign: 'center',
		zIndex: 2,
		color: 'white',
		paddingY: '10px',
		position: 'relative',
	},
	textStyle: {
		textAlign: 'center',

		display: 'inline',
		fontSize: { xs: '9.5px', mobileMid: '11.5px' },
		color: 'colors.dark6',
	},
	iconStyle: {
		position: 'absolute',
		right: 10,
		top: 13,
		cursor: 'pointer',
	},
};
